import { ButtonLink, Text, useIsMobile } from '@pm/ui';
import { useTranslation } from 'react-i18next';

type NotFoundProps = {
  supportLink?: string;
};

export const NotFound = ({ supportLink }: NotFoundProps) => {
  const { t } = useTranslation(['global', 'not-found-page']);
  const { isMobile } = useIsMobile();
  const buttonsSize = isMobile ? 'large' : 'small';

  return (
    <div className="space-y-xxxl mt-xxxl max-w-[624px] sm:px-4 px-1 mx-auto">
      <div className="space-y-l">
        <Text size="headingL">{t('not-found-page:Title')}</Text>
        <Text size="bodyL">{t('not-found-page:ContactUsDescription')}</Text>
      </div>
      <div className="space-y-m sm:flex flex-col items-start">
        <div>
          <ButtonLink to="/" size={buttonsSize}>
            {t('not-found-page:BackToTreatmentDetails')}
          </ButtonLink>
        </div>
        <div>
          <ButtonLink
            to={supportLink ?? t('global:SupportLinks.Canada.ZendeskRequest')}
            size={buttonsSize}
            intent="ghost"
            width="full"
            external
          >
            {t('not-found-page:ContactUs')}
          </ButtonLink>
        </div>
      </div>
    </div>
  );
};
